import { render, staticRenderFns } from "./FieldItemInfo.vue?vue&type=template&id=2e29665b&scoped=true"
import script from "./FieldItemInfo.vue?vue&type=script&lang=js"
export * from "./FieldItemInfo.vue?vue&type=script&lang=js"
import style0 from "./FieldItemInfo.vue?vue&type=style&index=0&id=2e29665b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e29665b",
  null
  
)

export default component.exports